import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './period.css';
import { dateFormateSend, getValidPeriodDate, dateFormateShow } from '../../../Date_Formate_Utilitiy/Index';
import Footer from '../../../home_page/Footer';
import { closeModal } from '../../../../redux/actions/action-creator';
import useClickOutside from '../../../Custom_Hooks/useClickOutsSide';

const Period = (props) => {

  const dispatch = useDispatch();
  const [date, setDate] = useState({ from: '', to: '', show_date: '' });

  const fromInputRef = useRef(null);
  const toInputRef = useRef(null);

  const { company_session } = useSelector(state => state.common);

  const handleFromDateChange = (inputValue) => {
    const parsedDate = getValidPeriodDate(inputValue, company_session);
    if (!parsedDate) {
      alert('Invalid date');
      return;
    }

    setDate(prev => ({
      ...prev,
      from: parsedDate.formattedDateString,
      show_date: parsedDate.formattedDateString
    }));

    toInputRef.current?.focus();
  };

  const handleToDateChange = (inputValue) => {
    if (!date.show_date) {
      alert('Please enter from date first');
      return;
    }

    const parsedDate = getValidPeriodDate(inputValue, company_session, date.show_date);
    if (!parsedDate) {
      alert('Invalid date format.');
      return;
    }

    const fromDate = new Date(date.show_date);
    const toDate = new Date(parsedDate.formattedDateString);

    // Validate date range
    if (toDate < fromDate) {
      alert('To date must be after from date');
      return;
    }

    props?.setDate({
      ...props.date,
      show_from_date: date.show_date,
      show_to_date: parsedDate.formattedDateString,
      send_from_date: dateFormateSend(date.show_date),
      send_to_date: dateFormateSend(parsedDate.formattedDateString)
    });

    dispatch(closeModal('period'));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDate(prev => ({ ...prev, [name]: value }));
  };

  const handleKeyUp = (e) => {
    const { name, value } = e.target;

    if (e.key === 'Enter') {
      e.preventDefault();

      if (name === 'from') {
        let inputValue = value.trim();
        if (inputValue === '') {
          if (company_session?.start_financial_year) {
            inputValue = new Date(company_session.start_financial_year).toLocaleDateString('en-GB').replace(/\//g, '.');
          }
        }
        handleFromDateChange(inputValue);
      } else if (name === 'to') {
        let inputValue = value.trim();
        if (inputValue === '') {
          if (company_session?.end_financial_year) {
            inputValue = new Date(company_session.end_financial_year).toLocaleDateString('en-GB').replace(/\//g, '.');
          }
        }
        handleToDateChange(inputValue);
      }
    }
  };

  const handleClickOutside = (event) => {
    if (fromInputRef.current) {
      event.preventDefault();
      fromInputRef.current.focus();
    }
  };

  const handleClickInside = (event) => {
    let clickedElement = event.target;
    if (clickedElement?.tagName && (clickedElement?.tagName.toLowerCase() === 'input' || clickedElement?.tagName.toLowerCase() === 'textarea')) {
      clickedElement.focus();
    }
  };


  useClickOutside(handleClickOutside, handleClickInside);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        dispatch(closeModal('period'));
        e.stopPropagation();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [dispatch]);

  useEffect(() => {
    if (props.setLoading) {
      props.setLoading(false);
    }

    let initialFrom = props.date?.show_from_date;
    let initialTo = props.date?.show_to_date;

    if (!initialFrom && props.date?.send_from_date) {
      initialFrom = dateFormateShow(props.date.send_from_date);
    }
    if (!initialTo && props.date?.send_to_date) {
      initialTo = dateFormateShow(props.date.send_to_date);
    }

    setDate(prev => ({
      ...prev,
      from: initialFrom || '',
      to: initialTo || '',
      show_date: initialFrom || ''
    }));

    setTimeout(() => {
      if (fromInputRef.current) {
        fromInputRef.current.focus();
        fromInputRef.current.select();
      }
    }, 100);
  }, []);
  return (
    <div className='my-card'>
      <div className='cross_button' onClick={() => dispatch(closeModal('period'))}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>

      <div className='container pb-3' id='card-period'>
        <div className='row'>
          <div className='col'>
            <b className='border-bottom'>Change Period</b>
          </div>
        </div>

        <div className='row'>
          <form autoComplete='off' onSubmit={(e) => e.preventDefault()}>
            <div className='col'>
              <div className='d-flex justify-content-between align-item-center'>
                <label className='lab-1'>From</label>
                <label>:</label>
                <input
                  type='text'
                  name='from'
                  id='from'
                  ref={fromInputRef}
                  onChange={handleChange}
                  onKeyUp={handleKeyUp}
                  onFocus={(e) => e.target.select()}
                  value={date.from || props.date.show_from_date}
                  className='lab-right'
                />
              </div>

              <div className='d-flex justify-content-between align-item-center'>
                <label className='lab-1'>To</label>
                <label>:</label>
                <input
                  type='text'
                  name='to'
                  id='to'
                  ref={toInputRef}
                  onChange={handleChange}
                  onKeyUp={handleKeyUp}
                  onFocus={(e) => e.target.select()}
                  value={date.to || props.date.show_to_date}
                  className='lab-right'
                />
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className='tomasterfooter'>
        <Footer />
      </div>
    </div>
  );
}

export default Period;
